const actions = {
  GET_GENERAL_INFOS_REQUEST: 'GET_GENERAL_INFOS_REQUEST',
  GET_GENERAL_INFOS_RESPONSE: 'GET_GENERAL_INFOS_RESPONSE',

  GET_CLINICS_WITH_MOST_PATIENTS_REQUEST: 'GET_CLINICS_WITH_MOST_PATIENTS_REQUEST',
  GET_CLINICS_WITH_MOST_PATIENTS_RESPONSE: 'GET_CLINICS_WITH_MOST_PATIENTS_RESPONSE',

  GET_USERS_WITH_MOST_PATIENTS_REQUEST: 'GET_USERS_WITH_MOST_PATIENTS_REQUEST',
  GET_USERS_WITH_MOST_PATIENTS_RESPONSE: 'GET_USERS_WITH_MOST_PATIENTS_RESPONSE',

  GET_BACKGROUND_LOGS_REQUEST: 'GET_BACKGROUND_LOGS_REQUEST',
  GET_BACKGROUND_LOGS_RESPONSE: 'GET_BACKGROUND_LOGS_RESPONSE',

  GET_GENERAL_LOGS_REQUEST: 'GET_GENERAL_LOGS_REQUEST',
  GET_GENERAL_LOGS_RESPONSE: 'GET_GENERAL_LOGS_RESPONSE',

  GET_DATABASES_REQUEST: "GET_DATABASES_REQUEST",
  GET_DATABASES_RESPONSE: "GET_DATABASES_RESPONSE",

  GET_BACKUPS_REQUEST: "GET_BACKUPS_REQUEST",
  GET_BACKUPS_RESPONSE: "GET_BACKUPS_RESPONSE",

  RESET_LOGS_DATA: 'RESET_LOGS_DATA',
  GET_LOGS_REQUEST: "GET_LOGS_REQUEST",
  GET_LOGS_RESPONSE: "GET_LOGS_RESPONSE",

  RESET_CLINICS_DETAILS_DATA: 'RESET_CLINICS_DETAILS_DATA',
  GET_CLINIC_DETAILS_REQUEST: "GET_CLINIC_DETAILS_REQUEST",
  GET_CLINIC_DETAILS_RESPONSE: "GET_CLINIC_DETAILS_RESPONSE",

  CREATE_NEW_USER_REQUEST: "CREATE_NEW_USER_REQUEST",
  CREATE_NEW_USER_RESPONSE: "CREATE_NEW_USER_RESPONSE",

  UPDATE_USER_REQUEST: "UPDATE_USER_REQUEST",
  UPDATE_USER_RESPONSE: "UPDATE_USER_RESPONSE",

  GET_USER_PERMISSIONS_REQUEST: "GET_USER_PERMISSIONS_REQUEST",
  GET_USER_PERMISSIONS_RESPONSE: "GET_USER_PERMISSIONS_RESPONSE",

  GET_USER_DETAILS_REQUEST: 'GET_USER_DETAILS_REQUEST',
  GET_USER_DETAILS_RESPONSE: 'GET_USER_DETAILS_RESPONSE',

  CHANGE_USER_PASSWORD_REQUEST: 'CHANGE_USER_PASSWORD_REQUEST',
  CHANGE_USER_PASSWORD_RESPONSE: 'CHANGE_USER_PASSWORD_RESPONSE',

  CHANGE_USER_STATUS_REQUEST: 'CHANGE_USER_STATUS_REQUEST',
  CHANGE_USER_STATUS_RESPONSE: 'CHANGE_USER_STATUS_RESPONSE',

  RESET_USER_AUDIT_LOGS_DATA: 'RESET_USER_AUDIT_LOGS_DATA',
  GET_USER_AUDIT_LOGS_REQUEST: 'GET_USER_AUDIT_LOGS_REQUEST',
  GET_USER_AUDIT_LOGS_RESPONSE: 'GET_USER_AUDIT_LOGS_RESPONSE',

  RESET_USER_BACKGROUND_JOBS: 'RESET_USER_BACKGROUND_JOBS',
  GET_USER_BACKGROUND_JOBS_REQUEST: 'GET_USER_BACKGROUND_JOBS_REQUEST',
  GET_USER_BACKGROUND_JOBS_RSPONSE: 'GET_USER_BACKGROUND_JOBS_RSPONSE',

  RESET_CLINIC_BACKGROUND_JOBS: 'RESET_CLINIC_BACKGROUND_JOBS',
  GET_CLINIC_BACKGROUND_JOBS_REQUEST: 'GET_CLINIC_BACKGROUND_JOBS_REQUEST',
  GET_CLINIC_BACKGROUND_JOBS_RSPONSE: 'GET_CLINIC_BACKGROUND_JOBS_RSPONSE',

  GET_CLINIC_NAMES_REQUEST: 'GET_CLINIC_NAMES_REQUEST',
  GET_CLINIC_NAMES_RESPONSE: 'GET_CLINIC_NAMES_RESPONSE',

  GET_USER_NAMES_REQUEST: 'GET_USER_NAMES_REQUEST',
  GET_USER_NAMES_RESPONSE: 'GET_USER_NAMES_RESPONSE',

  SET_BACKUPS_FILTER: 'SET_BACKUPS_FILTER',

  GET_DAILY_STATISTICS_FOR_DAY_REQUEST: 'GET_DAILY_STATISTICS_FOR_DAY_REQUEST',
  GET_DAILY_STATISTICS_FOR_DAY_RESPONSE: 'GET_DAILY_STATISTICS_FOR_DAY_RESPONSE',

  GET_DAILY_STATISTICS_FOR_PERIOD_REQUEST: 'GET_DAILY_STATISTICS_FOR_PERIOD_REQUEST',
  GET_DAILY_STATISTICS_FOR_PERIOD_RESPONSE: 'GET_DAILY_STATISTICS_FOR_PERIOD_RESPONSE',

  GET_WEEKLY_STATISTICS_REQUEST: 'GET_WEEKLY_STATISTICS_REQUEST',
  GET_WEEKLY_STATISTICS_RESPONSE: 'GET_WEEKLY_STATISTICS_RESPONSE',

  GET_AVAILABLE_PERMISSIONS_REQUEST: "GET_AVAILABLE_PERMISSIONS_REQUEST",
  GET_AVAILABLE_PERMISSIONS_RESPONSE: "GET_AVAILABLE_PERMISSIONS_RESPONSE",

  getGeneralInfos: () => ({
    type: actions.GET_GENERAL_INFOS_REQUEST,
  }),
  getClinicsWithMostPatients: () => ({
    type: actions.GET_CLINICS_WITH_MOST_PATIENTS_REQUEST,
  }),
  getUsersWithMostPatients: () => ({
    type: actions.GET_USERS_WITH_MOST_PATIENTS_REQUEST,
  }),
  getBackgroundLogs: () => ({
    type: actions.GET_BACKGROUND_LOGS_REQUEST
  }),
  getGeneralErrorLogs: () => ({
    type: actions.GET_GENERAL_LOGS_REQUEST
  }),
  getDatabases: () => ({
    type: actions.GET_DATABASES_REQUEST
  }),
  getBackups: () => ({
    type: actions.GET_BACKUPS_REQUEST
  }),
  resetLogs: () => ({
    type: actions.RESET_LOGS_DATA
  }),
  getLogs: (filters) => ({
    type: actions.GET_LOGS_REQUEST,
    filters
  }),
  resetClinicsDetailsData: () => ({
    type: actions.RESET_CLINICS_DETAILS_DATA
  }),
  getClinicDetails: (clinicId) => ({
    type: actions.GET_CLINIC_DETAILS_REQUEST,
    clinicId
  }),
  createNewUser: (values, clinicId) => ({
    type: actions.CREATE_NEW_USER_REQUEST,
    values,
    clinicId
  }),
  updateUser: (values, clinicId, userId) => ({
    type: actions.UPDATE_USER_REQUEST,
    values,
    clinicId,
    userId,
  }),
  getUserDetails: (userId) => ({
    type: actions.GET_USER_DETAILS_REQUEST,
    userId
  }),
  getUserPermissions: (userId) => ({
    type: actions.GET_USER_PERMISSIONS_REQUEST,
    userId
  }),
  changeUserPassword: (userId, values) => ({
    type: actions.CHANGE_USER_PASSWORD_REQUEST,
    userId, values
  }),
  changeUserStatus: (userId, status) => ({
    type: actions.CHANGE_USER_STATUS_REQUEST,
    userId,
    status
  }),
  resetUserAuditLogsData: () => ({
    type: actions.RESET_USER_AUDIT_LOGS_DATA
  }),
  getUserAuditLogs: (filters) => ({
    type: actions.GET_USER_AUDIT_LOGS_REQUEST,
    filters
  }),
  resetUserBackgroundJobs: ()=> ({
    type: actions.RESET_USER_BACKGROUND_JOBS,
  }),
  getUserBackgroundJobs: (userId, filters) => ({
    type: actions.GET_USER_BACKGROUND_JOBS_REQUEST,
    userId, 
    filters
  }),
  resetClinicBackgroundJobs: ()=> ({
    type: actions.RESET_CLINIC_BACKGROUND_JOBS,
  }),
  getClinicBackgroundJobs: (clinicId, filters) => ({
    type: actions.GET_CLINIC_BACKGROUND_JOBS_REQUEST,
    clinicId, 
    filters
  }),
  setBackupsFilter: (filter) => ({
    type: actions.SET_BACKUPS_FILTER,
    filter
  }),
  getClinicNames: () => ({
    type: actions.GET_CLINIC_NAMES_REQUEST
  }),
  getUserNames: () => ({
    type: actions.GET_USER_NAMES_REQUEST
  }),
  getDailyStatisticsForDay:(day) => ({
    type: actions.GET_DAILY_STATISTICS_FOR_DAY_REQUEST,
    day
  }),

  getDailyStatisticsForPeriod:(dateFrom, dateUntil) => ({
    type: actions.GET_DAILY_STATISTICS_FOR_PERIOD_REQUEST,
    dateFrom,
    dateUntil
  }),
  getWeeklyStatistics:(dayInWeek) => ({
    type: actions.GET_WEEKLY_STATISTICS_REQUEST,
    day: dayInWeek
  }),
  getAvailablePermissions:() => ({
    type: actions.GET_AVAILABLE_PERMISSIONS_REQUEST
  })
};
export default actions;
